import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import ClientLayout from '../../layouts/ClientLayout';

const Account = () => {
  const [activeTab, setActiveTab] = useState('personal');
  const [isEditing, setIsEditing] = useState(false);
  const [profileData, setProfileData] = useState({
    firstName: '',
    lastName: '',
    email: 'kristin.watson@example.com',
    phone: '(252) 555-0126',
    address: '4140 Parker Rd. Allentown, New Mexico 31134'
  });

  const handleInputChange = (e) => {
    setProfileData({
      ...profileData,
      [e.target.name]: e.target.value
    });
  };

  const handleSave = () => {
    setIsEditing(false);
    console.log('Profil sauvegardé:', profileData);
  };

  const handleCancel = () => {
    setIsEditing(false);
    // Réinitialiser les données si nécessaire
  };

  const renderTabContent = () => {
    switch (activeTab) {
      case 'personal':
        return (
          <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
            {/* Header avec avatar et bouton modifier */}
            <div className="flex items-center justify-between mb-6">
              <div className="flex items-center space-x-4">
                <div className="relative">
                  <div className="w-20 h-20 bg-gray-300 rounded-full flex items-center justify-center">
                  <img src="/svg/user-placeholder.svg" alt="avatar" className="w-20 h-20 object-cover rounded-full" />

                  </div>
                  {isEditing && (
                    <button className="absolute -bottom-1 -right-1 w-6 h-6 bg-orange-light rounded-full flex items-center justify-center">
                      <svg className="w-3 h-3 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z" />
                      </svg>
                    </button>
                  )}
                </div>
                <div>
                  <h2 className="text-xl font-semibold text-gray-900">Stephane Happi</h2>
                  <p className="text-gray-600">happistephanell@gmail.com</p>
                </div>
              </div>
              
              {!isEditing ? (
                <button
                  onClick={() => setIsEditing(true)}
                  className="bg-orange-hover text-white text-sm px-6 py-2 rounded-full flex items-center space-x-2 hover:bg-orange-700 transition-colors"
                >
                  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z" />
                  </svg>
                  <span>Modifier le profil</span>
                </button>
              ) : (
                <div className="flex space-x-3">
                  <button
                    onClick={handleSave}
                    className="bg-green-600 text-white px-4 py-2 rounded-lg hover:bg-green-700 transition-colors"
                  >
                    Sauvegarder
                  </button>
                  <button
                    onClick={handleCancel}
                    className="bg-gray-500 text-white px-4 py-2 rounded-lg hover:bg-gray-600 transition-colors"
                  >
                    Annuler
                  </button>
                </div>
              )}
            </div>

            {/* Formulaire */}
            <form className="space-y-6">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                {/* Nom */}
                <div>
                  <label htmlFor="lastName" className="block text-sm font-medium text-gray-700 mb-2">
                    Nom *
                  </label>
                  <input
                    type="text"
                    id="lastName"
                    name="lastName"
                    value={profileData.lastName}
                    onChange={handleInputChange}
                    disabled={!isEditing}
                    className={`w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-light focus:border-transparent transition-all duration-200 ${
                      isEditing ? 'bg-white' : 'bg-gray-50'
                    }`}
                    placeholder="Votre nom"
                  />
                </div>

                {/* Prénom */}
                <div>
                  <label htmlFor="firstName" className="block text-sm font-medium text-gray-700 mb-2">
                    Prénom *
                  </label>
                  <input
                    type="text"
                    id="firstName"
                    name="firstName"
                    value={profileData.firstName}
                    onChange={handleInputChange}
                    disabled={!isEditing}
                    className={`w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-light focus:border-transparent transition-all duration-200 ${
                      isEditing ? 'bg-white' : 'bg-gray-50'
                    }`}
                    placeholder="Votre prénom"
                  />
                </div>

                {/* Téléphone */}
                <div>
                  <label htmlFor="phone" className="block text-sm font-medium text-gray-700 mb-2">
                    Téléphone
                  </label>
                  <input
                    type="tel"
                    id="phone"
                    name="phone"
                    value={profileData.phone}
                    onChange={handleInputChange}
                    disabled={!isEditing}
                    className={`w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-light focus:border-transparent transition-all duration-200 ${
                      isEditing ? 'bg-white' : 'bg-gray-50'
                    }`}
                    placeholder="Votre numéro de téléphone"
                  />
                </div>

                {/* Email */}
                <div>
                  <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-2">
                    Adresse mail *
                  </label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={profileData.email}
                    onChange={handleInputChange}
                    disabled={!isEditing}
                    className={`w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-light focus:border-transparent transition-all duration-200 ${
                      isEditing ? 'bg-white' : 'bg-gray-50'
                    }`}
                    placeholder="Votre adresse email"
                  />
                </div>
              </div>

              {/* Adresse */}
              <div>
                <label htmlFor="address" className="block text-sm font-medium text-gray-700 mb-2">
                  Adresse
                </label>
                <textarea
                  id="address"
                  name="address"
                  value={profileData.address}
                  onChange={handleInputChange}
                  disabled={!isEditing}
                  rows={3}
                  className={`w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-light focus:border-transparent transition-all duration-200 ${
                    isEditing ? 'bg-white' : 'bg-gray-50'
                  }`}
                  placeholder="Votre adresse complète"
                />
              </div>
            </form>
          </div>
        );

      case 'orders':
        return (
          <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
            
            {/* En-têtes de la table */}
            <div className="hidden md:grid md:grid-cols-12 gap-4 mb-4">
              <div className="font-medium text-gray-700 md:col-span-5">Produit</div>
              <div className="font-medium text-gray-700 text-center md:col-span-2">Prix</div>
              <div className="font-medium text-gray-700 text-center md:col-span-2">Quantité</div>
              <div className="font-medium text-gray-700 text-center md:col-span-2">Total</div>
              <div className="font-medium text-gray-700 text-center md:col-span-1">Status</div>
            </div>

            {/* Liste des commandes */}
            <div className="space-y-4">
              {/* Commande 1 */}
              <div className="border-b border-gray-200 py-2">
                <div className="md:grid md:grid-cols-12 md:gap-4 md:items-center">
                  {/* Produit */}
                  <div className="flex items-center space-x-3 mb-3 md:mb-0 md:col-span-5">
                    <img 
                      src="/images/shop28-intro-imgae-2.png" 
                      alt="Chaise d'intérieur" 
                      className="w-16 h-16 object-cover rounded-lg flex-shrink-0"
                      onError={(e) => {
                        e.target.src = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='64' height='64' viewBox='0 0 64 64'%3E%3Crect width='64' height='64' fill='%23f3f4f6'/%3E%3Cpath d='M20 20h24v24H20z' fill='%23d1d5db'/%3E%3C/svg%3E"
                      }}
                    />
                    <div className="min-w-0 flex-1">
                      <h4 className="font-medium text-gray-900 text-s leading-tight">Chaise d'intérieur Space Gray (9th Generation)</h4>
                    </div>
                  </div>
                  
                  {/* Prix */}
                  <div className="text-center mb-2 md:mb-0 md:col-span-2">
                    <span className="font-medium text-gray-900">120.500 Fcfa</span>
                  </div>
                  
                  {/* Quantité */}
                  <div className="text-center mb-2 md:mb-0 md:col-span-2">
                    <span className="text-gray-700">2</span>
                  </div>
                  
                  {/* Total */}
                  <div className="text-center mb-2 md:mb-0 md:col-span-2">
                    <span className="font-medium text-gray-900">120.500 Fcfa</span>
                  </div>
                  
                  {/* Status */}
                  <div className="text-center md:col-span-1">
                    <span className="inline-flex px-3 py-1 text-sm border border-green-300 bg-green-100 text-green-700 rounded-full">
                      Effectuée
                    </span>
                  </div>
                </div>
              </div>

              {/* Commande 2 */}
              <div className="border-b border-gray-200 py-2">
                <div className="md:grid md:grid-cols-12 md:gap-4 md:items-center">
                  {/* Produit */}
                  <div className="flex items-center space-x-3 mb-3 md:mb-0 md:col-span-5">
                    <img 
                      src="/images/shop28-intro-imgae-2.png" 
                      alt="Statue en bois" 
                      className="w-16 h-16 object-cover rounded-lg flex-shrink-0"
                      onError={(e) => {
                        e.target.src = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='64' height='64' viewBox='0 0 64 64'%3E%3Crect width='64' height='64' fill='%23f3f4f6'/%3E%3Cpath d='M20 20h24v24H20z' fill='%23d1d5db'/%3E%3C/svg%3E"
                      }}
                    />
                    <div className="min-w-0 flex-1">
                      <h4 className="font-medium text-gray-900 text-sm leading-tight">Chaise d'intérieur Space Gray (9th Generation)</h4>
                    </div>
                  </div>
                  
                  {/* Prix */}
                  <div className="text-center mb-2 md:mb-0 md:col-span-2">
                    <span className="font-medium text-gray-900">120.500 Fcfa</span>
                  </div>
                  
                  {/* Quantité */}
                  <div className="text-center mb-2 md:mb-0 md:col-span-2">
                    <span className="text-gray-700">2</span>
                  </div>
                  
                  {/* Total */}
                  <div className="text-center mb-2 md:mb-0 md:col-span-2">
                    <span className="font-medium text-gray-900">120.500 Fcfa</span>
                  </div>
                  
                  {/* Status */}
                  <div className="text-center md:col-span-1">
                    <span className="inline-flex px-3 py-1 text-sm border border-red-300 bg-red-100 text-red-700 rounded-full">
                      Annulée
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        );

      case 'favorites':
        return (
          <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
            <h3 className="text-lg font-semibold text-gray-900 mb-6">Mes favoris</h3>
            
            {/* Grille des produits favoris */}
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
              {/* Produit 1 - Nectar au Baobab/Tamarin */}
              <div className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden">
                <div className="relative">
                  <img 
                    src="/images/baobab-tamarin.jpg" 
                    alt="Nectar au Baobab/Tamarin" 
                    className="w-full h-48 object-cover"
                    onError={(e) => {
                      e.target.src = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='300' height='200' viewBox='0 0 300 200'%3E%3Crect width='300' height='200' fill='%23f3f4f6'/%3E%3Cpath d='M50 50h200v100H50z' fill='%23d1d5db'/%3E%3C/svg%3E"
                    }}
                  />
                  <div className="absolute top-2 left-2">
                    <button className="w-8 h-8 bg-red-500 rounded-full flex items-center justify-center hover:bg-red-600 transition-colors">
                      <svg className="w-4 h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                      </svg>
                    </button>
                  </div>
                  <div className="absolute top-2 right-2">
                    <div className="w-8 h-8 bg-white rounded-full flex items-center justify-center shadow-sm">
                      <svg className="w-4 h-4 text-red-500" fill="currentColor" viewBox="0 0 24 24">
                        <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z" />
                      </svg>
                    </div>
                  </div>
                  <div className="absolute top-2 left-12">
                    <span className="px-2 py-1 bg-gray-100 text-gray-700 text-xs rounded-full">Artisanat</span>
                  </div>
                </div>
                
                <div className="p-4">
                  <h4 className="font-medium text-gray-900 text-sm mb-2">Nectar au Baobab/Tamarin</h4>
                  
                  <div className="flex items-center space-x-2 mb-2">
                    <span className="text-gray-400 line-through text-sm">78.000 Fcfa</span>
                    <span className="text-orange-hover font-semibold">41.500 Fcfa</span>
                    <span className="px-2 py-1 bg-red-100 text-red-600 text-xs rounded-full">-79%</span>
                  </div>
                  
                  <div className="flex items-center mb-2">
                    <div className="flex text-yellow-400">
                      {[...Array(5)].map((_, i) => (
                        <svg key={i} className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
                          <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
                        </svg>
                      ))}
                    </div>
                    <span className="text-gray-500 text-xs ml-2">(85 avis clients)</span>
                  </div>
                  
                  <p className="text-gray-600 text-xs mb-3">Mobidas Sarl</p>
                  
                  <button className="w-full bg-orange-hover text-white py-2 px-4 rounded-lg flex items-center justify-center space-x-2 hover:bg-orange-700 transition-colors">
                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 3h2l.4 2M7 13h10l4-8H5.4m0 0L7 13m0 0l-2.5 5M7 13l2.5 5m6-5v6a2 2 0 01-2 2H9a2 2 0 01-2-2v-6m6 0V9a2 2 0 00-2-2H9a2 2 0 00-2 2v4.01" />
                    </svg>
                    <span>Ajouter au panier</span>
                  </button>
                </div>
              </div>

              {/* Produit 2 - Nectar au Baobab */}
              <div className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden">
                <div className="relative">
                  <img 
                    src="/images/baobab-sculpture.jpg" 
                    alt="Nectar au Baobab" 
                    className="w-full h-48 object-cover"
                    onError={(e) => {
                      e.target.src = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='300' height='200' viewBox='0 0 300 200'%3E%3Crect width='300' height='200' fill='%23f3f4f6'/%3E%3Cpath d='M50 50h200v100H50z' fill='%23d1d5db'/%3E%3C/svg%3E"
                    }}
                  />
                  <div className="absolute top-2 left-2">
                    <button className="w-8 h-8 bg-red-500 rounded-full flex items-center justify-center hover:bg-red-600 transition-colors">
                      <svg className="w-4 h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                      </svg>
                    </button>
                  </div>
                  <div className="absolute top-2 right-2">
                    <div className="w-8 h-8 bg-white rounded-full flex items-center justify-center shadow-sm">
                      <svg className="w-4 h-4 text-red-500" fill="currentColor" viewBox="0 0 24 24">
                        <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z" />
                      </svg>
                    </div>
                  </div>
                  <div className="absolute top-2 left-12">
                    <span className="px-2 py-1 bg-gray-100 text-gray-700 text-xs rounded-full">Artisanat</span>
                  </div>
                </div>
                
                <div className="p-4">
                  <h4 className="font-medium text-gray-900 text-sm mb-2">Nectar au Baobab</h4>
                  
                  <div className="flex items-center space-x-2 mb-2">
                    <span className="text-gray-400 line-through text-sm">18.000 Fcfa</span>
                    <span className="text-orange-hover font-semibold">14.500 Fcfa</span>
                    <span className="px-2 py-1 bg-red-100 text-red-600 text-xs rounded-full">-19%</span>
                  </div>
                  
                  <div className="flex items-center mb-2">
                    <div className="flex text-yellow-400">
                      {[...Array(5)].map((_, i) => (
                        <svg key={i} className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
                          <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
                        </svg>
                      ))}
                    </div>
                    <span className="text-gray-500 text-xs ml-2">(85 avis clients)</span>
                  </div>
                  
                  <p className="text-gray-600 text-xs mb-3">Mobidas Sarl</p>
                  
                  <button className="w-full bg-white border border-gray-300 text-gray-700 py-2 px-4 rounded-lg flex items-center justify-center space-x-2 hover:bg-gray-50 transition-colors">
                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 3h2l.4 2M7 13h10l4-8H5.4m0 0L7 13m0 0l-2.5 5M7 13l2.5 5m6-5v6a2 2 0 01-2 2H9a2 2 0 01-2-2v-6m6 0V9a2 2 0 00-2-2H9a2 2 0 00-2 2v4.01" />
                    </svg>
                    <span>Ajouter au panier</span>
                  </button>
                </div>
              </div>

              {/* Produit 3 - Masque de culture */}
              <div className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden">
                <div className="relative">
                  <img 
                    src="/images/tribal-mask.jpg" 
                    alt="Masque de culture" 
                    className="w-full h-48 object-cover"
                    onError={(e) => {
                      e.target.src = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='300' height='200' viewBox='0 0 300 200'%3E%3Crect width='300' height='200' fill='%23f3f4f6'/%3E%3Cpath d='M50 50h200v100H50z' fill='%23d1d5db'/%3E%3C/svg%3E"
                    }}
                  />
                  <div className="absolute top-2 left-2">
                    <button className="w-8 h-8 bg-red-500 rounded-full flex items-center justify-center hover:bg-red-600 transition-colors">
                      <svg className="w-4 h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                      </svg>
                    </button>
                  </div>
                  <div className="absolute top-2 right-2">
                    <div className="w-8 h-8 bg-white rounded-full flex items-center justify-center shadow-sm">
                      <svg className="w-4 h-4 text-red-500" fill="currentColor" viewBox="0 0 24 24">
                        <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z" />
                      </svg>
                    </div>
                  </div>
                  <div className="absolute top-2 left-12">
                    <span className="px-2 py-1 bg-gray-100 text-gray-700 text-xs rounded-full">Artisanat</span>
                  </div>
                </div>
                
                <div className="p-4">
                  <h4 className="font-medium text-gray-900 text-sm mb-2">Masque de culture</h4>
                  
                  <div className="flex items-center space-x-2 mb-2">
                    <span className="text-gray-400 line-through text-sm">18.000 Fcfa</span>
                    <span className="text-orange-hover font-semibold">10.000 Fcfa</span>
                    <span className="px-2 py-1 bg-red-100 text-red-600 text-xs rounded-full">-19%</span>
                  </div>
                  
                  <div className="flex items-center mb-2">
                    <div className="flex text-yellow-400">
                      {[...Array(5)].map((_, i) => (
                        <svg key={i} className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
                          <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
                        </svg>
                      ))}
                    </div>
                    <span className="text-gray-500 text-xs ml-2">(85 avis clients)</span>
                  </div>
                  
                  <p className="text-gray-600 text-xs mb-3">Mobidas Sarl</p>
                  
                  <button className="w-full bg-white border border-gray-300 text-gray-700 py-2 px-4 rounded-lg flex items-center justify-center space-x-2 hover:bg-gray-50 transition-colors">
                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 3h2l.4 2M7 13h10l4-8H5.4m0 0L7 13m0 0l-2.5 5M7 13l2.5 5m6-5v6a2 2 0 01-2 2H9a2 2 0 01-2-2v-6m6 0V9a2 2 0 00-2-2H9a2 2 0 00-2 2v4.01" />
                    </svg>
                    <span>Ajouter au panier</span>
                  </button>
                </div>
              </div>

              {/* Produit 4 - Chaise d'intérieur */}
              <div className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden">
                <div className="relative">
                  <img 
                    src="/images/modern-chair.jpg" 
                    alt="Chaise d'intérieur" 
                    className="w-full h-48 object-cover"
                    onError={(e) => {
                      e.target.src = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='300' height='200' viewBox='0 0 300 200'%3E%3Crect width='300' height='200' fill='%23f3f4f6'/%3E%3Cpath d='M50 50h200v100H50z' fill='%23d1d5db'/%3E%3C/svg%3E"
                    }}
                  />
                  <div className="absolute top-2 left-2">
                    <button className="w-8 h-8 bg-red-500 rounded-full flex items-center justify-center hover:bg-red-600 transition-colors">
                      <svg className="w-4 h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                      </svg>
                    </button>
                  </div>
                  <div className="absolute top-2 right-2">
                    <div className="w-8 h-8 bg-white rounded-full flex items-center justify-center shadow-sm">
                      <svg className="w-4 h-4 text-red-500" fill="currentColor" viewBox="0 0 24 24">
                        <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z" />
                      </svg>
                    </div>
                  </div>
                  <div className="absolute top-2 left-12">
                    <span className="px-2 py-1 bg-gray-100 text-gray-700 text-xs rounded-full">Meuble</span>
                  </div>
                </div>
                
                <div className="p-4">
                  <h4 className="font-medium text-gray-900 text-sm mb-2">Chaise d'intérieur</h4>
                  
                  <div className="flex items-center space-x-2 mb-2">
                    <span className="text-gray-400 line-through text-sm">200.000 Fcfa</span>
                    <span className="text-orange-hover font-semibold">120.500 Fcfa</span>
                    <span className="px-2 py-1 bg-red-100 text-red-600 text-xs rounded-full">-25%</span>
                  </div>
                  
                  <div className="flex items-center mb-2">
                    <div className="flex text-yellow-400">
                      {[...Array(5)].map((_, i) => (
                        <svg key={i} className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
                          <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
                        </svg>
                      ))}
                    </div>
                    <span className="text-gray-500 text-xs ml-2">(85 avis clients)</span>
                  </div>
                  
                  <p className="text-gray-600 text-xs mb-3">Mobidas Sarl</p>
                  
                  <button className="w-full bg-white border border-gray-300 text-gray-700 py-2 px-4 rounded-lg flex items-center justify-center space-x-2 hover:bg-gray-50 transition-colors">
                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 3h2l.4 2M7 13h10l4-8H5.4m0 0L7 13m0 0l-2.5 5M7 13l2.5 5m6-5v6a2 2 0 01-2 2H9a2 2 0 01-2-2v-6m6 0V9a2 2 0 00-2-2H9a2 2 0 00-2 2v4.01" />
                    </svg>
                    <span>Ajouter au panier</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        );

      case 'addresses':
        return (
          <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
            <h3 className="text-lg font-semibold text-gray-900 mb-4">Gérer les adresses</h3>
            <p className="text-gray-600">Aucune adresse enregistrée pour le moment.</p>
          </div>
        );

      case 'password':
        return (
          <div className="bg-white rounded-lg shadow-sm border border-gray-200">
            <div className="flex items-start justify-between">
            <img src="/svg/secure-data.svg" alt="secure-data" className="w-52 h-52" />

              <button className="mt-6 mr-6 bg-orange-hover text-white px-6 py-2 rounded-full hover:bg-orange-700 transition-colors">
                Sauvegarder
              </button>
            </div>
            
            <div className="flex flex-col lg:flex-row gap-8 p-6 pt-0">
              
              {/* Formulaire */}
              <div className="lg:w-full">
                <form className="space-y-4">
                  {/* Ancien mot de passe */}
                  <div>
                    <label htmlFor="oldPassword" className="block text-sm font-medium text-gray-700 mb-2">
                      Ancien mot de passe *
                    </label>
                    <input
                      type="password"
                      id="oldPassword"
                      name="oldPassword"
                      defaultValue="••••••••"
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-light focus:border-transparent transition-all duration-200"
                      placeholder="Votre ancien mot de passe"
                    />
                  </div>
                  
                  {/* Nouveaux mots de passe */}
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <div>
                      <label htmlFor="newPassword" className="block text-sm font-medium text-gray-700 mb-2">
                        Nouveau mot de passe *
                      </label>
                      <input
                        type="password"
                        id="newPassword"
                        name="newPassword"
                        defaultValue="••••••••"
                        className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-light focus:border-transparent transition-all duration-200"
                        placeholder="Votre nouveau mot de passe"
                      />
                    </div>
                    
                    <div>
                      <label htmlFor="confirmPassword" className="block text-sm font-medium text-gray-700 mb-2">
                        Confirmer le nouveau mot de passe *
                      </label>
                      <input
                        type="password"
                        id="confirmPassword"
                        name="confirmPassword"
                        defaultValue="••••••••"
                        className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-light focus:border-transparent transition-all duration-200"
                        placeholder="Confirmez votre nouveau mot de passe"
                      />
                    </div>
                  </div>
                  
                  {/* Conseils de sécurité */}
                  {/* <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
                    <h4 className="text-sm font-medium text-blue-800 mb-2">Conseils pour un mot de passe sécurisé :</h4>
                    <ul className="text-sm text-blue-700 space-y-1">
                      <li>• Utilisez au moins 8 caractères</li>
                      <li>• Incluez des lettres majuscules et minuscules</li>
                      <li>• Ajoutez des chiffres et des symboles</li>
                      <li>• Évitez les informations personnelles</li>
                    </ul>
                  </div> */}
                </form>
              </div>
            </div>
          </div>
        );

      default:
        return null;
    }
  };

  return (
    <ClientLayout>
      <div className="flex-1 md:mx-8 lg:mx-16 mx-auto py-8">
        {/* Breadcrumb */}
        <div className="mb-6">
          <nav className="text-sm text-gray-600">
            <Link to="/" className="hover:text-gray-900">Accueil</Link>
            <span className="mx-2">&gt;</span>
            <span className="text-gray-900">Compte</span>
          </nav>
        </div>

        <div className="flex flex-col lg:flex-row gap-8">
          {/* Sidebar de navigation */}
          <div className="lg:w-80 flex-shrink-0">
            {/* Carte de profil utilisateur */}
            <div className="bg-white rounded-lg rounded-b-none shadow-sm border border-gray-200 border-b-0 p-4">
              <div className="flex items-center space-x-4">
                <div className="w-12 h-12 bg-gray-300 rounded-full flex items-center justify-center">
                  <img src="/svg/user-placeholder.svg" alt="avatar" className="w-12 h-12 object-cover rounded-full" />
                </div>
                <div>
                  <h3 className="font-semibold text-gray-900">Stephane Happi</h3>
                  <p className="text-sm text-gray-600">happistephanell@gmail.com</p>
                </div>
              </div>
            </div>

            {/* Menu de navigation */}
            <nav className="bg-white shadow-sm border border-gray-200">
              <div className="">
                {[
                  { id: 'personal', label: 'Informations personnelles', icon: 'user' },
                  { id: 'orders', label: 'Historique des commandes', icon: 'box' },
                  { id: 'favorites', label: 'Mes favoris', icon: 'heart' },
                  { id: 'addresses', label: 'Gérer les adresses', icon: 'location' },
                  { id: 'password', label: 'Mot de passe', icon: 'gear' }
                ].map((item) => (
                  <button
                    key={item.id}
                    onClick={() => setActiveTab(item.id)}
                    className={`w-full flex items-center space-x-3 px-4 py-3 text-left transition-colors ${
                      activeTab === item.id
                        ? 'bg-orange-hover text-white'
                        : 'text-gray-700 hover:bg-gray-50'
                    }`}
                  >
                    <div className={`w-5 h-5 ${
                      activeTab === item.id ? 'text-white' : 'text-gray-400'
                    }`}>
                      {item.icon === 'user' && (
                        <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                        </svg>
                      )}
                      {item.icon === 'box' && (
                        <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4" />
                        </svg>
                      )}
                      {item.icon === 'heart' && (
                        <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
                        </svg>
                      )}
                      {item.icon === 'location' && (
                        <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314-11.314z" />
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                        </svg>
                      )}
                      {item.icon === 'gear' && (
                        <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                        </svg>
                      )}
                    </div>
                    <span className="font-">{item.label}</span>
                  </button>
                ))}
              </div>
            </nav>
          </div>

          {/* Contenu principal */}
          <div className="flex-1">
            {renderTabContent()}
          </div>
        </div>
      </div>
    </ClientLayout>
  );
};

export default Account;
